module.exports = __webpack_public_path__ + "static/fielder-logo-1b2011dc1f0d245a3b36ff015df87397.png";